<div *ngIf="isActivePage(menuName)">
  <ng-content></ng-content>
</div>
